import * as React from "react";
import { SVGProps } from "react";

const Airswap = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 602 603" {...props}>
    <path
      fill="#2b71ff"
      d="M452.8 451.9 301 603.7l-75.3-75.3c81.2-4.8 159.6-31.2 227.1-76.5zM596.7 296l-18.6-18.5L301 .3 23.8 277.5 0 301.3l8.6 7.4c9.7 8.1 19.7 15.8 30 23 109.6 77.2 245.5 100.5 371 69.8 51.2-12.4 99.8-33.7 143.7-62.9 10.9-7.2 21.5-15 31.9-23.2 5.7-4.6 11.3-9.3 16.8-14.1zm-222.6 69.7c-82.7-50.8-177.9-77.5-274.9-77.1 126.4-55.1 281.5-62.6 423.7 19.2-45.3 28.8-95.9 48.5-148.8 57.9z"
    />
  </svg>
);

export default Airswap;
